<template>
    <div class="items-center p-4 text-center">
        <div
          :class="[ 'animate-spin inline-block', sizeSpinner, 'border-[3px] border-current border-t-transparent text-blue-600 rounded-full']"
          role="status"
          aria-label="loading"
        >
        <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>
<script  setup lang="ts">
const { sizeSpinner = 'size-4'} = defineProps<{
  sizeSpinner?: string
}>()
</script>
